// mutations
export const SET_FIELDS = 'SET_FIELDS';

// getters
export const SIGNUP_COMPLETE = 'SIGNUP_COMPLETE';
export const ORG_COMPLETE = 'ORG_COMPLETE';
export const TEAM_COMPLETE_OR_SKIPPED = 'TEAM_COMPLETE_OR_SKIPPED';
export const PERSONAL_FORM_COMPLETE = 'PERSONAL_FORM_COMPLETE';

// actions
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';
